require 'plugins/pure/pure-min.css'
require 'plugins/icomoon/style.css'
require 'plugins/swiper/dist/css/swiper.min.css'
require 'plugins/flexslider/flexslider.css'
require 'plugins/animate.css/animate.min.css'
require 'plugins/sweetalert/lib/sweet-alert.css'
require 'styles/common/util.scss'
require 'styles/common/common1.scss'
require 'styles/pages/colp.scss'

require 'script!jquery'
require 'script!affix'
require '../common/form-validation.coffee'
require 'script!ajaxform'
require 'script!jquery_colorbox'
require '../common/city.coffee'
require '../common/fast-nav.coffee'
require 'script!plugins/swiper/dist/js/swiper.jquery.js'
#require './colpJs.js'

$ ->
  $form_fix = $('.form_fix')
  $(window).scroll () ->
    if $(window).scrollTop() < 400
      $form_fix.fadeOut()
    else
      $form_fix.fadeIn()
###do ->
  $swiperProcess = $('#swiper-process')
  $swiper = new Swiper $swiperProcess,{
    autoplay: 3000,
    prevButton:'.swiper-button-prev',
    nextButton:'.swiper-button-next',
    pagination:'.swiper-pagination',
    paginationClickable :true,
    spaceBetween: 5,
    loop : true,
    autoheight : true,
    autoplayDisableOnInteraction : false,
  }###

# 报价部分js
do ->
  if $('#yuyue_form').length > 0
    $form = $('#yuyue_form')
    $truename = $form.find '[name="truename"]'
    $mobile = $form.find '[name="mobile"]'
    success_url=$("#success_url").val()

    # 表单验证
    $form.validate
      errorPlacement: (error, element)->
        swal {
          title: error[0].innerHTML
          allowOutsideClick: true
        }
      submitHandler: (form)->
        phoneNumber=form.elements.mobile.value.trim()
        userId="MOBI#{phoneNumber}"
        $(form).ajaxSubmit {
          dataType: 'json'
          data: {
            rnd: parseInt(Math.random()*1e7,10)+(new Date()).getTime()
          }
          error: ->
            swal {
              title: '对不起，出错了，请稍后重试！'
              allowOutsideClick: true
            }
          success: (res)->
            if res.msg[0].type is 'success'
              swal {
                customClass: 'alert-success'
                title: '<img class="form_success" src="'+success_url+'" alt="">'
                confirmButtonText: '返  回'
                confirmButtonColor: '#3b9bff'
                allowOutsideClick: true
                html: true
              }
              # swal {
              #   customClass: 'success'
              #   text: '微信关注&nbsp;“<span class="blue">蘑菇装修</span>”&nbsp;获取更多装修优惠'
              #   title: '<img class="form_success" src="'+$img_src+'" alt="">'
              #   allowOutsideClick: true
              #   confirmButtonText: '确认'
              #   confirmButtonColor: '#166fd3'
              #   html: true
              # }
            if res.msg[0].type is 'error'
              swal {
                title: res.msg[0].info
                allowOutsideClick: true
              }
              return false
        }
        return false

    $truename.rules 'add',{
      required: true
      messages: {
        required: '请输入您的姓名'
      }
    }

    $mobile.rules 'add',{
      required: true
      mobileNum: true
      messages: {
        required: '请输入11位手机号码'
        mobileNum: '请输入正确的手机号'
      }
    }
# 报价部分js
do ->
  $cshhr = $('#cshhrbtn')
  $cshhrclose = $('.cshhrclose')
  $colpmask = $('.colpmask')

  $cshhr.bind 'click', (evt)->
    evt.preventDefault()
    $colpmask.show()

  $cshhrclose .bind 'click', (evt)->
    evt.preventDefault()
    $colpmask.hide()


# 表单弹窗
do ->
  if $('#fromSubmit').length > 0
    $form = $('#fromSubmit')
    $area = $form.find '[name="area"]'
    $mobile = $form.find '[name="mobile"]'
    $dl = $form.find '[name="dl"]'
    $agreement = $form.find '[name = agreement]'

    # 表单验证
    $form.validate
      errorPlacement: (error, element)->
        swal {
          title: error[0].innerHTML
          allowOutsideClick: false
        }
      submitHandler: (form)->
        phoneNumber=form.elements.mobile.value.trim()
        userId="MOBI#{phoneNumber}"

        $(form).ajaxSubmit {
          dataType: 'json'
          data: {
            rnd: parseInt(Math.random()*1e7,10)+(new Date()).getTime()
          }
          error: ->
            swal {
              title: '对不起，出错了，请稍后重试！'
              allowOutsideClick: true
            }
          success: (res)->
            if res.msg?[0]?.type is 'success'
              window._agl and window._agl.push(['track', ['success', {t: 3}]])
              if $dl.val()
                swal({
                  title: '您的信息已提交成功，请注意短信查收报价结果!',
                  allowOutsideClick: true
                })
              else
                swal({
                  customClass: 'alert-success',
                  title: '<img class="form_success" src="http://p.51zx.com/FuK_TJTSwVZBR7Ho2nAj1_z3THKw" alt="">',
                  confirmButtonText: '返  回',
                  confirmButtonColor: '#3b9bff',
                  allowOutsideClick: true,
                  html: true,
                  timer:1000000
                })
            if res.msg[0].type is 'error'
              swal {
                title: res.msg[0].info
                allowOutsideClick: true
              }
              return false
        }
        return false

    if $agreement.length
      $agreement.rules 'add',{
        required: true
        messages: {
          required: '请勾选已阅读并同意积木家的用户协议'
        }
      }

    if $area.length
      $area.rules 'add',
        required: true
        messages:
          required: '请输入装修面积'

    if $mobile.length
      $mobile.rules 'add',
        required: true
        mobileNum: true
        messages:
          required: '请输入11位手机号码'
          mobileNum: '请输入正确的手机号'


do ->
  if $('#cshhrfrom').length > 0
    $form = $('#cshhrfrom')
    $truename = $form.find '[name="truename"]'
    $mobile = $form.find '[name="mobile"]'
    $imageCity = $form.find '[name="imageCity"]'
    success_url=$("#success_url").val()
    $colpmask = $('.colpmask')
    # 表单验证
    $form.validate
      errorPlacement: (error, element)->
        swal {
          title: error[0].innerHTML
          allowOutsideClick: true
        }
      submitHandler: (form)->
        phoneNumber=form.elements.mobile.value.trim()
        userId="MOBI#{phoneNumber}"
        $(form).ajaxSubmit {
          dataType: 'json'
          data: {
            rnd: parseInt(Math.random()*1e7,10)+(new Date()).getTime()
          }
          error: ->
            swal {
              title: '对不起，出错了，请稍后重试！'
              allowOutsideClick: true
            }
          success: (res)->
            if res.msg[0].type is 'success'
              $colpmask.hide()
              swal {
                customClass: 'alert-success'
                title: '<img class="form_success" src="http://p.51zx.com/FnUeQxS48RolFiKq0ygMOuZ-MZFS" alt="">'
                confirmButtonText: '返  回'
                confirmButtonColor: '#3b9bff'
                allowOutsideClick: true
                html: true
              }
              $truename.val('')
              $mobile.val('')
              $imageCity.val('')

            if res.msg[0].type is 'error'
              swal {
                title: res.msg[0].info
                allowOutsideClick: true
              }
              return false
        }
        return false

    $truename.rules 'add',{
      required: true
      messages: {
        required: '请输入您的姓名'
      }
    }
    $imageCity.rules 'add',{
      required: true
      messages: {
        required: '请输入计划开店城市'
      }
    }
    $mobile.rules 'add',{
      required: true
      mobileNum: true
      messages: {
        required: '请输入11位手机号码'
        mobileNum: '请输入正确的手机号'
      }
    }
do ->
  $rightFloat=$('#right-float')
  $kefu=$('#kefu')
  $yuyuefix=$('.yuyuefix')
  $mfdh=$('.mfdh')
  if $kefu.length>0
    if $yuyuefix.length>0
      iHeight = $rightFloat.offset().top
      $height=$("body").height()-($(window).height()-136)
      $(window).scroll ->
        $mfdh.hide()
        scrollTop = $(window).scrollTop()
        if $height<=scrollTop
          $yuyuefix.stop().animate(bottom:-85,50)
        else if  480<= scrollTop
          $rightFloat.stop().animate(right:30,50)
          $yuyuefix.stop().animate(bottom:0,50)
        else
          $rightFloat.stop().animate(right:-70,50)
          $yuyuefix.stop().animate(bottom:-85,50)



/** WEBPACK FOOTER **
 ** /root/workspace/jimujia-pc_4ez2/wwwroot/static/~/coffeelint-loader!./colp.coffee
 **/